<h2 mat-dialog-title>{{ data.patient ? 'Chat about ' + data.patient.title : data.mode === 'channel' ? 'New group' : data.mode === 'network' ? 'Message a medical professional' : data.mode === 'billing' ? 'Message your billing team' : 'New message' }}</h2>

<mat-dialog-content>
  <div class="field-column">
    <ng-container *ngIf="data.mode === 'channel'">
      <mat-form-field appearance="outline">
        <mat-label>Group name</mat-label>
        <input matInput [(ngModel)]="name" maxlength="80" required placeholder="e.g. theatre-team" cdkFocusInitial />
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>What is it for? (optional)</mat-label>
        <input matInput [(ngModel)]="description" maxlength="500" />
      </mat-form-field>
      <mat-radio-group color="primary" [(ngModel)]="visibility" class="visibility">
        <mat-radio-button value="public">Public: anyone in the practice can find and join it</mat-radio-button>
        <mat-radio-button value="private">Private: invitation only (practice admins can still see it)</mat-radio-button>
      </mat-radio-group>
    </ng-container>

    <!-- Billing team (2026-10-05): which team, when the practice has more than one billing it. -->
    <ng-container *ngIf="data.mode === 'billing'">
      <p class="network-hint" *ngIf="!data.patient">Your billing team on MedicAI Connect. They see only the chats you start with them and the
        practice's billing room, never your other chats.</p>
      <p class="network-hint" *ngIf="data.patient">Who on your billing team to ask about {{ data.patient.title }}. The patient
        is tagged in your first message. Pick nobody to write in the practice's shared billing chat.</p>
      <p class="network-empty" *ngIf="!loading && !billingTeams.length">Your practice has no billing team on MedicAI
        Connect yet.</p>
      <mat-form-field appearance="outline" *ngIf="billingTeams.length > 1">
        <mat-label>Billing team</mat-label>
        <mat-select [ngModel]="billingOrgId" (ngModelChange)="pickBillingTeam($event)">
          <mat-option *ngFor="let t of billingTeams" [value]="t.otherOrgId">{{ t.otherName || 'Billing team' }}</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="outline" *ngIf="selectedIds.length > 1">
        <mat-label>Group name (optional)</mat-label>
        <input matInput [(ngModel)]="groupName" maxlength="80" />
      </mat-form-field>
    </ng-container>

    <!-- The task dialog's "Assigned to" field, for people: a multiple select of the practice's members. -->
    <mat-form-field appearance="outline" *ngIf="data.mode !== 'network' && (data.mode !== 'billing' || billingTeams.length)">
      <mat-label>{{ data.mode === 'channel' ? 'Members' : 'To' }}</mat-label>
      <mat-select [(ngModel)]="selectedIds" multiple [placeholder]="data.mode === 'channel' ? 'Just you for now' : 'Choose people'" [disabled]="loading">
        <mat-select-trigger>{{ selectedNames }}</mat-select-trigger>
        <mat-option *ngFor="let p of people" [value]="p.principalId" [disabled]="full(p)">
          <span class="face" [style.--hue]="faceHue(p)">
            <img *ngIf="facePhoto(p) as src; else personLetters" [src]="src" alt="" loading="lazy" />
            <ng-template #personLetters>{{ faceInitials(p) }}</ng-template>
          </span>{{ p.name }}
        </mat-option>
      </mat-select>
      <mat-hint *ngIf="data.mode === 'message' || data.mode === 'billing'">One person for a private conversation, up to eight for a group.</mat-hint>
      <mat-hint *ngIf="data.mode === 'channel'">You can add people later.</mat-hint>
    </mat-form-field>
  </div>

  <!--
    Referral network (2026-09-22): a 1-on-1 with someone outside the practice it is linked with. Picking a person opens
    the chat at once; nothing about a patient is shared by it.
  -->
  <section class="network" *ngIf="showNetwork">
    <h3 class="network-title"><mat-icon>share</mat-icon>Medical professionals</h3>
    <p class="network-hint">A private chat with a clinician outside your practice. Patients you link in it are not shared
      with them until you refer the patient.</p>
    <label class="network-search" *ngIf="network.length">
      <mat-icon>search</mat-icon>
      <input [(ngModel)]="networkQuery" placeholder="Name, speciality or practice" aria-label="Search medical professionals" />
    </label>
    <div class="loading" *ngIf="networkLoading"><mat-spinner diameter="22"></mat-spinner></div>
    <p class="network-empty" *ngIf="networkError">{{ networkError }}</p>
    <p class="network-empty" *ngIf="!networkLoading && !networkError && !network.length">
      No medical professionals linked yet. A practice administrator links clinicians and practices under
      Settings → MedicAI Network.</p>
    <p class="network-empty" *ngIf="network.length && !networkShown.length">Nobody matches.</p>
    <div class="network-link" *ngFor="let l of networkShown; trackBy: trackLink">
      <div class="network-practice">
        <mat-icon>{{ l.kind === 'practice' ? 'local_hospital' : 'person_outline' }}</mat-icon>
        {{ l.kind === 'practice' ? (l.practiceName || 'Linked practice') : 'Outside MedicAI' }}
      </div>
      <button type="button" class="network-person" *ngFor="let p of l.people" (click)="startNetwork(l, p)"
        [disabled]="!!openingKey" [attr.aria-label]="'Chat with ' + p.displayName + (p.email ? ' (' + p.email + ')' : '')">
        <span class="face" [style.--hue]="personHue(l, p)">{{ faceInitials({ name: p.displayName }) }}</span>
        <span class="network-who">
          <span class="network-name">{{ p.displayName }}</span>
          <span class="network-meta" *ngIf="personMeta(l, p) as meta">{{ meta }}</span>
          <span class="network-email" *ngIf="p.email" [class.shared]="nameShared(p)">
            <mat-icon>mail_outline</mat-icon>{{ p.email }}</span>
        </span>
        <mat-spinner diameter="18" *ngIf="openingKey === personKey(l, p)"></mat-spinner>
        <mat-icon class="network-go" *ngIf="openingKey !== personKey(l, p)">chat_bubble_outline</mat-icon>
      </button>
    </div>
  </section>

  <div class="loading" *ngIf="loading"><mat-spinner diameter="24"></mat-spinner></div>
  <p class="error" *ngIf="error">{{ error }}</p>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cancel</button>
  <button mat-flat-button color="primary" (click)="create()" [disabled]="!canCreate" *ngIf="data.mode !== 'network'">
    {{ data.mode === 'channel' ? 'Create group' : (selectedIds.length > 1 ? 'Start group message' : selectedIds.length === 0 && data.patient ? 'Write in the billing chat' : 'Start conversation') }}
  </button>
</mat-dialog-actions>
